module.exports = __webpack_public_path__ + "img/ee.70d03cb4.svg";